export const GameFrameModuleName = Symbol('GameFrameModule');